/**
 * @file crm-pipeline-view.ts
 * @description Как показать воронку и стадию сделок в настройках (phase19.31,
 * зона «Клиенты и сделки»): описание воронки без служебного текста сида,
 * вторая линия строки стадии.
 */

import { pluralRu } from "./plural";

/**
 * Описание из стартовых данных — служебный текст разработчика («Pre-sales
 * воронка B2C… → WON. Дальше — Order Канбан»): коды стадий капсом латиницей
 * и стрелки. Такое описание кабинет не показывает (данные не правим — это
 * отдельная задача), человеческое описание магазина — показывает.
 */
export function isServiceDescription(text: string | null | undefined): boolean {
  const value = (text ?? "").trim();
  if (!value) return true;
  return /\b[A-Z]{3,}\b/.test(value) || value.includes("→") || /\bpre-sales\b/i.test(value);
}

/** Описание для показа или `null`. */
export function pipelineDescription(text: string | null | undefined): string | null {
  return isServiceDescription(text) ? null : (text ?? "").trim();
}

/** «5 стадий». */
export function stagesCountText(count: number): string {
  return `${count} ${pluralRu(count, ["стадия", "стадии", "стадий"])}`;
}

/** Вторая линия строки стадии: «3 сделки · срок 24 ч». */
export function stageSecondLine(stage: { dealsCount: number; slaHours: number | null }): string {
  const deals = `${stage.dealsCount} ${pluralRu(stage.dealsCount, ["сделка", "сделки", "сделок"])}`;
  return stage.slaHours ? `${deals} · срок ${stage.slaHours} ч` : deals;
}
